import $ from 'jquery';
import ga from "ga";
import getCandidatureTrackingCategory from "./tracking_offres_perf";
import {trackerDepotCV, trackerPostuler} from "./abtasty";

/**
 * Tracking redirection apres candidature a une offre
 */
export default function (customOptions) {
  const options = {
    retourCandidature: false,
    avaitDejaUnCv: false,
    isNouveauCvUploade: false,
    isAvecCreationCompte: false,
    isOffreExterne: false,
    offreSource: null,
    nomEntreprise: null
  };
  if (customOptions) {
    $.extend(options, customOptions);
  }

  if (options.retourCandidature) {
    if (options.isOffreExterne) {
      // Les offres externes en formulaire sont des offres � la perf
      ga.sendEvent(getCandidatureTrackingCategory(options.offreSource), 'candidature_formulaire', options.nomEntreprise);
    } else {
      ga.sendEvent('candidature', 'candidature_formulaire');
    }
    trackerPostuler();

    if (!options.avaitDejaUnCv) {
      ga.sendEvent('depot_cv', 'depot_cv', 'via_candidature');
      trackerDepotCV();
    } else if (options.isNouveauCvUploade) {
      ga.sendEvent('depot_cv', 'maj_cv', 'via_candidature');
      trackerDepotCV();
    }

    if (options.isAvecCreationCompte) {
      ga.sendEvent('creation_compte', 'creation_compte', 'via_candidature');
    }
  }
}
